/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AmsVidMappingParam
 */
export interface AmsVidMappingParam {
    /**
     * 
     * @type {string}
     * @memberof AmsVidMappingParam
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmsVidMappingParam
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof AmsVidMappingParam
     */
    vid: string;
}

/**
 * Check if a given object implements the AmsVidMappingParam interface.
 */
export function instanceOfAmsVidMappingParam(value: object): value is AmsVidMappingParam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('vid' in value) || value['vid'] === undefined) return false;
    return true;
}

export function AmsVidMappingParamFromJSON(json: any): AmsVidMappingParam {
    return AmsVidMappingParamFromJSONTyped(json, false);
}

export function AmsVidMappingParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmsVidMappingParam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'zipCode': json['zipCode'],
        'vid': json['vid'],
    };
}

export function AmsVidMappingParamToJSON(json: any): AmsVidMappingParam {
    return AmsVidMappingParamToJSONTyped(json, false);
}

export function AmsVidMappingParamToJSONTyped(value?: AmsVidMappingParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'zipCode': value['zipCode'],
        'vid': value['vid'],
    };
}

